"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _aphrodite = require("aphrodite");

var _reactDom = require("react-dom");

var _styling = require("../toolkit/styling");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  popupContent: {
    tooltip: {
      position: "absolute",
      zIndex: "999",
      background: "rgb(255, 255, 255)",
      borderRadius: "5px",
      boxShadow: "0 4px 6px 0 rgba(175, 199, 209, 0.4)",
      border: "solid 1px rgba(175, 199, 209, 0.5)",
      marginBottom: "100px",
      opacity: 1
    },
    modal: {
      position: "relative",
      background: "rgb(255, 255, 255)",
      width: "50%",
      margin: "auto",
      borderRadius: "5px",
      border: "solid 1px rgba(175, 199, 209, 0.5)",
      opacity: 1
    }
  },
  popupArrow: {
    height: "10px",
    width: "10px",
    position: "absolute",
    background: "rgb(255, 255, 255)",
    transform: "rotate(45deg)",
    margin: "-5px",
    zIndex: "-1",
    boxShadow: "rgba(0, 0, 0, 0.2) 1px 1px 1px"
  },
  overlay: {
    tooltip: {
      position: "fixed",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      borderRadius: "5px",
      overflow: "hidden"
    },
    modal: {
      borderRadius: "5px",
      overflow: "hidden",
      position: "fixed",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      background: "rgba(0, 0, 0,0.5)",
      display: "flex",
      zIndex: "999"
    }
  }
}; // eslint-disable-next-line local-rules/no-large-method-params

var calculatePosition = function calculatePosition(triggerBounding, ContentBounding, position, arrow, offset) {
  var margin = arrow ? 8 : 0;
  var MarginX = margin + offset.offsetX;
  var MarginY = margin + offset.offsetY;
  var args = position.split(" "); // the step N 1 : center the popup content => ok

  var CenterTop = triggerBounding.top + triggerBounding.height / 2;
  var CenterLeft = triggerBounding.left + triggerBounding.width / 2;
  var height = ContentBounding.height,
      width = ContentBounding.width;
  var top = CenterTop - height / 2;
  var left = CenterLeft - width / 2;
  var transform = "";
  var arrowTop = "0%";
  var arrowLeft = "0%"; // the  step N 2 : => ok

  switch (args[0]) {
    case "top":
      top -= height / 2 + triggerBounding.height / 2 + MarginY;
      transform = "rotate(45deg)";
      arrowTop = "100%";
      arrowLeft = "50%";
      break;

    case "bottom":
      top += height / 2 + triggerBounding.height / 2 + MarginY;
      transform = "rotate(225deg)";
      arrowLeft = "50%";
      break;

    case "left":
      left -= width / 2 + triggerBounding.width / 2 + MarginX;
      transform = " rotate(-45deg)";
      arrowLeft = "100%";
      arrowTop = "50%";
      break;

    case "right":
      left += width / 2 + triggerBounding.width / 2 + MarginX;
      transform = "rotate(135deg)";
      arrowTop = "50%";
      break;
  }

  switch (args[1]) {
    case "top":
      top = triggerBounding.top;
      arrowTop = triggerBounding.height / 2 + "px";
      break;

    case "bottom":
      top = triggerBounding.top - height + triggerBounding.height;
      arrowTop = height - triggerBounding.height / 2 + "px";
      break;

    case "left":
      left = triggerBounding.left;
      arrowLeft = triggerBounding.width / 2 + "px";
      break;

    case "right":
      left = triggerBounding.left - width + triggerBounding.width;
      arrowLeft = width - triggerBounding.width / 2 + "px";
      break;
  }

  return {
    top: top,
    left: left,
    transform: transform,
    arrowLeft: arrowLeft,
    arrowTop: arrowTop
  };
};

var Popup = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Popup, _React$PureComponent);

  var _super = _createSuper(Popup);

  function Popup(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popup);
    _this = _super.call(this, props);
    _this.state = {
      isOpen: _this.props.open || _this.props.defaultOpen,
      modal: _this.props.modal ? true : !_this.props.trigger // we create this modal state because the popup can't be a tooltip if the
      // trigger prop doesn't existe

    };

    _this.onKeyup = function (e) {
      if (e.key === "Escape") _this.closePopup();
    };

    _this.onMousedown = function (e) {
      // If the click is inside the trigger or the content, we don't want to
      // dismiss the popup
      if (_this.TriggerEl && _this.TriggerEl.contains(e.target) || _this.ContentEl && _this.ContentEl.contains(e.target)) return; // If the click happened in a Portal(e.g DatePickerPopOver), dont want to
      // dismiss popup as well

      var el = e.target;

      while (el && el.tagName !== "BODY") {
        if (el.className && typeof el.className.indexOf === "function" && el.className.indexOf("Portal") !== -1) {
          return;
        }

        el = el.parentElement;
      }

      _this.closePopup();
    };

    _this.lockScroll = function () {
      if (_this.state.modal && _this.props.lockScroll) document.getElementsByTagName("body")[0].style.overflow = "hidden";
    };

    _this.resetScroll = function () {
      if (_this.state.modal && _this.props.lockScroll) document.getElementsByTagName("body")[0].style.overflow = "auto";
    };

    _this.togglePopup = function () {
      if (_this.state.isOpen) _this.closePopup();else _this.openPopup();
    };

    _this.openPopup = function () {
      if (_this.state.isOpen) return;

      _this.setState({
        isOpen: true
      }, function () {
        _this.setPosition();

        _this.props.onOpen();

        _this.lockScroll();
      });
    };

    _this.closePopup = function () {
      if (!_this.state.isOpen) return;

      _this.setState({
        isOpen: false
      }, function () {
        _this.props.onClose();

        _this.resetScroll();
      });
    };

    _this.onMouseEnter = function () {
      clearTimeout(_this.timeOut);
      var mouseEnterDelay = _this.props.mouseEnterDelay;
      _this.timeOut = setTimeout(function () {
        return _this.openPopup();
      }, mouseEnterDelay);
    };

    _this.onMouseLeave = function () {
      clearTimeout(_this.timeOut);
      var _this$props = _this.props,
          mouseLeaveDelay = _this$props.mouseLeaveDelay,
          closeOnMouseLeave = _this$props.closeOnMouseLeave;

      if (closeOnMouseLeave) {
        _this.timeOut = setTimeout(function () {
          return _this.closePopup();
        }, mouseLeaveDelay);
      }
    };

    _this.setPosition = function () {
      var _this$props2 = _this.props,
          arrow = _this$props2.arrow,
          position = _this$props2.position,
          offsetX = _this$props2.offsetX,
          offsetY = _this$props2.offsetY,
          contentWidth = _this$props2.contentWidth;
      var modal = _this.state.modal;
      if (modal) return;

      var helper = _this.HelperEl.getBoundingClientRect();

      var trigger = _this.TriggerEl.getBoundingClientRect();

      var content = _this.ContentEl.getBoundingClientRect();

      if (contentWidth != null) {
        content.width = contentWidth;
      }

      var cords = calculatePosition(trigger, content, position, arrow, {
        offsetX: offsetX,
        offsetY: offsetY
      });
      _this.ContentEl.style.top = cords.top - helper.top + "px";
      _this.ContentEl.style.left = cords.left - helper.left + "px";

      if (arrow) {
        _this.ArrowEl.style.transform = cords.transform;
        _this.ArrowEl.style["-ms-transform"] = cords.transform;
        _this.ArrowEl.style["-webkit-transform"] = cords.transform;
        _this.ArrowEl.style.top = cords.arrowTop;
        _this.ArrowEl.style.left = cords.arrowLeft;
      }

      if (window.getComputedStyle(_this.TriggerEl, null).getPropertyValue("position") == "static" || window.getComputedStyle(_this.TriggerEl, null).getPropertyValue("position").trim().length === 0) _this.TriggerEl.style.position = "relative";
    };

    _this.addWarperAction = function () {
      var _this$props3 = _this.props,
          contentStyle = _this$props3.contentStyle,
          className = _this$props3.className,
          on = _this$props3.on,
          position = _this$props3.position;
      var modal = _this.state.modal;
      var popupContentStyle = modal ? styles.popupContent.modal : styles.popupContent.tooltip;

      var additionalStyles = function () {
        var anchor = position.toLowerCase().split(" ")[0];

        var _ref = function () {
          if (anchor === "bottom") {
            return ["translate3d(0, -10px, 0)", "translate3d(0, 0, 0)"];
          } else if (anchor === "left") {
            return ["translate3d(-10px, 0, 0)", "translate3d(0, 0, 0)"];
          } else if (anchor === "right") {
            return ["translate3d(-10px, 0, 0)", "translate3d(0, 0, 0)"];
          }

          return ["translate3d(0, 10px, 0)", "translate3d(0, 0, 0)"];
        }(),
            _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            transformFrom = _ref2[0],
            transformTo = _ref2[1];

        var keyframes = {
          from: {
            transform: transformFrom,
            opacity: 0
          },
          to: {
            transform: transformTo,
            opacity: 1
          }
        };
        return _aphrodite.StyleSheet.create({
          popupContentStyle: {
            animationName: [keyframes],
            animationDuration: "200ms"
          }
        });
      }();

      var childrenElementProps = {
        className: (0, _styling.css)("popup-content ".concat(className), additionalStyles.popupContentStyle),
        style: Object.assign({}, popupContentStyle, contentStyle),
        ref: _this.setContentRef,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      };

      if (!modal && on.indexOf("hover") >= 0) {
        childrenElementProps.onMouseEnter = _this.onMouseEnter;
        childrenElementProps.onMouseLeave = _this.onMouseLeave;
      }

      return childrenElementProps;
    };

    _this.renderTrigger = function () {
      var triggerProps = {
        key: "T"
      };
      var _this$props4 = _this.props,
          on = _this$props4.on,
          trigger = _this$props4.trigger;
      var onAsArray = Array.isArray(on) ? on : [on];

      for (var i = 0, len = onAsArray.length; i < len; i++) {
        switch (onAsArray[i]) {
          case "click":
            triggerProps.onClick = _this.togglePopup;
            break;

          case "hover":
            triggerProps.onMouseEnter = _this.onMouseEnter;
            triggerProps.onMouseLeave = _this.onMouseLeave;
            break;

          case "focus":
            triggerProps.onFocus = _this.onMouseEnter;
            break;
        }
      }

      if (typeof trigger === "function") return /*#__PURE__*/_react["default"].cloneElement(trigger(_this.state.isOpen), triggerProps);
      return /*#__PURE__*/_react["default"].cloneElement(trigger, triggerProps);
    };

    _this.renderContent = function () {
      var _this$props5 = _this.props,
          arrow = _this$props5.arrow,
          arrowStyle = _this$props5.arrowStyle;
      var modal = _this.state.modal;
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, _this.addWarperAction(), {
        key: "C"
      }), arrow && !modal && /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this.setArrowRef,
        style: Object.assign({}, styles.popupArrow, arrowStyle)
      }), typeof _this.props.children === "function" ? _this.props.children(_this.closePopup, _this.state.isOpen) : _this.props.children);
    };

    _this.setTriggerRef = function (r) {
      return _this.TriggerEl = r;
    };

    _this.setContentRef = function (r) {
      return _this.ContentEl = r;
    };

    _this.setArrowRef = function (r) {
      return _this.ArrowEl = r;
    };

    _this.setHelperRef = function (r) {
      return _this.HelperEl = r;
    };

    _this.timeOut = 0;
    return _this;
  }

  (0, _createClass2["default"])(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
          closeOnEscape = _this$props6.closeOnEscape,
          defaultOpen = _this$props6.defaultOpen;
      if (defaultOpen) this.setPosition();

      if (closeOnEscape) {
        window.addEventListener("keyup", this.onKeyup);
      }

      window.addEventListener("mousedown", this.onMousedown);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    // Reason: this is a react lifecycle method, we can't rename it.
    // eslint-disable-next-line @typescript-eslint/naming-convention
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.open === nextProps.open) return;
      if (nextProps.open) this.openPopup();else this.closePopup();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // kill any function to execute if the component is unmounted
      clearTimeout(this.timeOut);
      window.removeEventListener("keyup", this.onKeyup);
      window.removeEventListener("mousedown", this.onMousedown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          overlayStyle = _this$props7.overlayStyle,
          closeOnDocumentClick = _this$props7.closeOnDocumentClick,
          on = _this$props7.on;
      var modal = this.state.modal;
      var overlay = this.state.isOpen && !(on.indexOf("hover") >= 0);
      var ovStyle = modal ? styles.overlay.modal : styles.overlay.tooltip;
      return [this.state.isOpen && /*#__PURE__*/_react["default"].createElement("div", {
        key: "H",
        style: {
          position: "absolute",
          top: "0px",
          left: "0px"
        },
        ref: this.setHelperRef
      }), overlay && /*#__PURE__*/_react["default"].createElement("div", {
        key: "O",
        className: "popup-overlay",
        style: Object.assign({}, ovStyle, overlayStyle),
        onClick: closeOnDocumentClick ? this.closePopup : undefined
      }, modal && this.renderContent()), this.state.isOpen && !modal && this.renderContent(), !!this.props.trigger && /*#__PURE__*/_react["default"].createElement(Ref, {
        innerRef: this.setTriggerRef,
        key: "R"
      }, this.renderTrigger())];
    }
  }]);
  return Popup;
}(_react["default"].PureComponent);

exports["default"] = Popup;
Popup.defaultProps = {
  children: function children() {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Your Content Here !!");
  },
  trigger: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  defaultOpen: false,
  open: false,
  closeOnDocumentClick: true,
  closeOnEscape: true,
  closeOnMouseLeave: true,
  on: ["click"],
  contentStyle: {},
  arrowStyle: {},
  overlayStyle: {},
  className: "",
  position: "bottom center",
  modal: false,
  lockScroll: false,
  arrow: true,
  offsetX: 0,
  offsetY: 0,
  mouseEnterDelay: 100,
  mouseLeaveDelay: 100
};

if (process.env.NODE_ENV !== "production") {
  var PropTypes = require("prop-types");

  Popup.propTypes = {
    arrowStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    overlayStyle: PropTypes.object,
    className: PropTypes.string,
    modal: PropTypes.bool,
    closeOnDocumentClick: PropTypes.bool,
    lockScroll: PropTypes.bool,
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
    mouseEnterDelay: PropTypes.number,
    mouseLeaveDelay: PropTypes.number,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    // for uncontrolled component we don't need the trigger Element
    trigger: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    on: PropTypes.oneOfType([PropTypes.oneOf(["hover", "click", "focus"]), PropTypes.arrayOf(PropTypes.oneOf(["hover", "click", "focus"]))]),
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string]).isRequired,
    position: PropTypes.oneOf(["top left", "top center", "top right", "bottom left", "bottom center", "bottom right", "right top", "right center", "right bottom", "left top", "left center", "left bottom"])
  };
}

var Ref = /*#__PURE__*/function (_React$PureComponent2) {
  (0, _inherits2["default"])(Ref, _React$PureComponent2);

  var _super2 = _createSuper(Ref);

  function Ref() {
    (0, _classCallCheck2["default"])(this, Ref);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(Ref, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var innerRef = this.props.innerRef;
      if (innerRef) innerRef((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].Children.only(children);
    }
  }]);
  return Ref;
}(_react["default"].PureComponent);